// src/components/users/UserCard.jsx
import React from 'react';
import { Edit2, Trash2, Lock } from 'lucide-react';
import {roles, RoleBadge } from './UserBadges';

const UserCard = ({ user, onEdit, onDelete, onChangePassword }) => {
  return (
    <div className="bg-white rounded-lg shadow">
      <div className="p-4">
        <div className="flex items-center justify-between">
          <div>
            <div className="font-medium">{user.full_name}</div>
            <div className="text-sm text-gray-500">{user.email}</div>
          </div>
          <RoleBadge role={user.role} />
        </div>
        
        <div className="mt-4">
          <div className="text-sm text-gray-500">Username</div>
          <div className="text-sm">{user.username}</div>
        </div>

        <div className="mt-4 flex items-center justify-between">
          <div className="text-sm text-gray-500">
            Managing {user.risk_count || 0} risks
          </div>
          <div className="space-x-2">
            <button 
              onClick={() => onEdit(user)}
              className="inline-flex items-center px-3 py-1 border border-gray-300 rounded text-sm text-gray-700 bg-white hover:bg-gray-50"
            >
              <Edit2 className="w-4 h-4 mr-1" />
              Edit
            </button>
            <button 
              onClick={() => onChangePassword(user)}
              className="inline-flex items-center px-3 py-1 border border-blue-300 rounded text-sm text-blue-700 bg-white hover:bg-blue-50"
            >
              <Lock className="w-4 h-4 mr-1" />
              Change Password
            </button>
            <button 
              onClick={() => onDelete(user.id)}
              className="inline-flex items-center px-3 py-1 border border-red-300 rounded text-sm text-red-700 bg-white hover:bg-red-50"
            >
              <Trash2 className="w-4 h-4 mr-1" />
              Delete
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserCard;
